(function(){
  function buildCatalog(){
    try{
      var handlesEl=document.getElementById('bs-product-handles');
      if(!handlesEl)return Promise.resolve([]);
      var data=JSON.parse(handlesEl.textContent);
      var products=data.products||[];
      if(products.length===0)return Promise.resolve([]);
      return Promise.resolve(products.map(function(prod){
        return{
          id:'prod-'+prod.id,
          productId:prod.id,
          name:prod.title,
          url:prod.url||'',
          image:prod.image||'',
          bpm:parseInt(prod.bpm)||100,
          key:prod.key||'C',
          genre:prod.genre||'Hip-Hop',
          audioUrl:prod.audioUrl||'',
          price:parseFloat(prod.price)||29.99,
          variantId:prod.variantId
        };
      }));
    }catch(e){
      return Promise.resolve([]);
    }
  }

  var ALL_BEATS=[];
  var bsFilterOpen=false;
  var bsQuery='';
  var bsGenre='All';
  var bsBpm='Any';
  var bsAddedSet={};
  var bsCartPending={};
  var bsActiveUrl=null;
  var bsIsPlayingGlobal=false;

  function getFiltered(){
    var q=bsQuery.trim().toLowerCase();
    return ALL_BEATS.filter(function(b){
      if(bsGenre!=='All'&&b.genre!==bsGenre)return false;
      if(bsBpm==='Under 100'&&b.bpm>=100)return false;
      if(bsBpm==='100-140'&&(b.bpm<100||b.bpm>140))return false;
      if(bsBpm==='Over 140'&&b.bpm<=140)return false;
      if(q&&!b.name.toLowerCase().includes(q)&&!b.genre.toLowerCase().includes(q))return false;
      return true;
    });
  }

  function buildQueueItem(b){
    return {
      name: b.name,
      url: b.audioUrl,
      packTitle: 'TRKVLT Beat Store',
      artwork: b.image || '',
      productId: b.productId,
      productUrl: b.url || '',
      variantId: b.variantId,
      price: '$' + (b.price || 0).toFixed(2)
    };
  }

  function playBeat(id){
    var filtered=getFiltered();
    var beat=filtered.filter(function(x){return x.id===id;})[0];
    if(!beat||!beat.audioUrl)return;
    var queue=filtered.map(buildQueueItem).filter(function(t){return t.url;});
    var idx=queue.findIndex(function(t){return t.url===beat.audioUrl;});
    if(window.TRKVLTPlayer)window.TRKVLTPlayer.playTrack(queue[idx>=0?idx:0],queue,idx>=0?idx:0);
  }

  function renderTracks(){
    var filtered=getFiltered();
    var list=document.getElementById('bs-track-list');
    var empty=document.getElementById('bs-empty-msg');
    if(!list)return;
    list.innerHTML='';
    if(filtered.length===0){if(empty)empty.style.display='block';return;}
    if(empty)empty.style.display='none';
    filtered.forEach(function(b){
      var isActive=b.audioUrl&&b.audioUrl===bsActiveUrl;
      var isAdded=!!bsAddedSet[b.id];
      var div=document.createElement('div');
      div.className='bs-trk'+(isActive?' active':'');
      /* The .bs-trk-price span is what snippets/member-price-badge.liquid hooks
         to append the Prod. Monthly member price. Renaming that class removes
         the member pricing from this page. */
      div.innerHTML=
        '<div style="display:flex;align-items:center;gap:14px;">'+
          '<div>'+
            '<div class="bs-trk-name" style="'+(isActive?'color:#F90D65;':'')+'">'+b.name+'</div>'+
            '<div class="bs-trk-prod">'+b.bpm+' BPM · '+b.key+'</div>'+
          '</div>'+
        '</div>'+
        '<div style="display:flex;align-items:center;gap:12px;" class="bs-trk-meta-tags">'+
          '<span class="bs-trk-tag">'+b.genre+'</span>'+
          '<span class="bs-trk-price">$'+(b.price||0).toFixed(2)+'</span>'+
        '</div>'+
        '<div style="display:flex;align-items:center;justify-content:flex-end;">'+
          '<button class="bs-trk-add'+(isAdded?' added':'')+'" data-beat-id="'+b.id+'" data-variant-id="'+b.variantId+'" aria-label="Add to cart">'+
            (isAdded
              ?'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>'
              :'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>')+
          '</button>'+
        '</div>';
      div.querySelector('.bs-trk-add').addEventListener('click',function(e){
        e.stopPropagation();
        bsToggleCart(this.dataset.beatId,this.dataset.variantId);
      });
      div.addEventListener('click',function(e){
        if(e.target.closest('.bs-trk-add'))return;
        /* Don't hijack a tap on the member-price link. */
        if(e.target.closest('.mp-badge-sm'))return;
        playBeat(b.id);
      });
      list.appendChild(div);
    });
  }

  function bsToggleCart(beatId,variantId){
    if(bsCartPending[beatId])return;
    bsCartPending[beatId]=true;
    var isAdded=!!bsAddedSet[beatId];
    if(isAdded){
      fetch(window.Shopify.routes.root+'cart.js')
        .then(function(r){return r.json();})
        .then(function(cart){
          var lineToRemove=null;
          if(cart.items){for(var i=0;i<cart.items.length;i++){if(cart.items[i].variant_id==variantId){lineToRemove=cart.items[i].key;break;}}}
          if(lineToRemove){
            return fetch(window.Shopify.routes.root+'cart/change.js',{
              method:'POST',headers:{'Content-Type':'application/json'},
              body:JSON.stringify({id:lineToRemove,quantity:0})
            }).then(function(r){return r.json();});
          }
        })
        .then(function(){return fetch(window.Shopify.routes.root+'cart.js').then(function(r){return r.json();}); })
        .then(function(cart){
          bsAddedSet[beatId]=false;
          if(typeof updateCartBadge==='function')updateCartBadge(cart.item_count);
          renderTracks();
        })
        .catch(function(){bsAddedSet[beatId]=true;})
        .finally(function(){bsCartPending[beatId]=false;});
    }else{
      if(variantId&&typeof fetch!=='undefined'){
        fetch(window.Shopify.routes.root+'cart/add.js',{
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(variantId),quantity:1}]})
        }).then(function(r){return r.json();})
        .then(function(){return fetch(window.Shopify.routes.root+'cart.js').then(function(r){return r.json();});})
        .then(function(cart){
          bsAddedSet[beatId]=true;
          if(typeof updateCartBadge==='function')updateCartBadge(cart.item_count);
          renderTracks();
        })
        .catch(function(){bsAddedSet[beatId]=false;})
        .finally(function(){bsCartPending[beatId]=false;});
      }else{
        bsCartPending[beatId]=false;
      }
    }
  }

  var searchInput=document.getElementById('bs-search-input');
  if(searchInput)searchInput.addEventListener('input',function(e){bsQuery=e.target.value;renderTracks();});

  var filterBtn=document.getElementById('bs-filter-btn');
  var filterPop=document.getElementById('bs-filter-pop');
  if(filterBtn&&filterPop){
    filterBtn.addEventListener('click',function(e){e.stopPropagation();bsFilterOpen=!bsFilterOpen;filterPop.style.display=bsFilterOpen?'flex':'none';filterBtn.className='bs-filter-btn'+(bsFilterOpen?' on':'');});
    document.addEventListener('click',function(){if(bsFilterOpen){bsFilterOpen=false;filterPop.style.display='none';filterBtn.className='bs-filter-btn';}});
    filterPop.addEventListener('click',function(e){e.stopPropagation();});
  }

  var genreSel=document.getElementById('bs-genre-sel');
  if(genreSel)genreSel.addEventListener('change',function(e){bsGenre=e.target.value;renderTracks();});
  var bpmSel=document.getElementById('bs-bpm-sel');
  if(bpmSel)bpmSel.addEventListener('change',function(e){bsBpm=e.target.value;renderTracks();});
  var clearBtn=document.getElementById('bs-clear-filters');
  if(clearBtn)clearBtn.addEventListener('click',function(){
    bsGenre='All';bsBpm='Any';
    if(genreSel)genreSel.value='All';
    if(bpmSel)bpmSel.value='Any';
    renderTracks();
  });

  var playAllBtn=document.getElementById('bs-play-all-btn');
  if(playAllBtn)playAllBtn.addEventListener('click',function(){
    var f=getFiltered();
    if(!f.length)return;
    var queue=f.map(buildQueueItem).filter(function(t){return t.url;});
    if(queue.length&&window.TRKVLTPlayer)window.TRKVLTPlayer.playTrack(queue[0],queue,0);
  });

  /* Visuals here are driven entirely by the global persistent player (see
     assets/global-player.js), so this page never owns any audio itself —
     play/pause/next/prev all keep working across navigation instead of
     resetting like the old page-local floating player did. */
  window.addEventListener('trkvltplayerupdate', function(e){
    bsActiveUrl = e.detail.url;
    bsIsPlayingGlobal = e.detail.playing;
    renderTracks();
  });

  buildCatalog().then(function(beats){
    ALL_BEATS=beats;
    var countLabel=document.getElementById('bs-total-count');
    if(countLabel)countLabel.textContent=ALL_BEATS.length+' beat'+(ALL_BEATS.length!==1?'s':'');
    fetch(window.Shopify.routes.root+'cart.js')
      .then(function(r){return r.json();})
      .then(function(cart){
        if(cart.items&&cart.items.length>0){
          cart.items.forEach(function(item){
            ALL_BEATS.forEach(function(beat){
              if(beat.variantId==item.variant_id)bsAddedSet[beat.id]=true;
            });
          });
        }
        renderTracks();
      }).catch(function(){renderTracks();});
  }).catch(function(){});
})();
